import React from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import { PlanHero } from "../../components/PlanHero/PlanHero";
import { PlanCard } from "../../components/PlanCard/PlanCard";

export const EverythingEverywhere = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.everythingAndEverywhere.title}</title>
        <meta
          name="description"
          content="Cityside’s 5 Gig Everything & Everywhere residential home connection is the ultimate high speed internet and WiFi experience. Sign up now!"
        />

        <meta property="og:title" content={`${ROUTES.everythingAndEverywhere.title}`} />
        <meta property="og:description" content="Cityside's 5 Gig Everything & Everywhere package is the ultimate plan for high-speed internet and WiFi coverage throughout your home. Sign up now!" />
        <meta property="og:url" content="https://www.citysidefiber.com/everything-and-everywhere" />
      </Helmet>

      <PlanHero type="5 Gigs">
        <h4 className="">
          This is the ultimate connection for those who want to cover it all and
          won&rsquo;t settle for less!
        </h4>

        <ul className="checkmark-list">
          <li>
            Kick back and enjoy SoCal&rsquo;s fastest and most reliable internet
            and WiFi experience that covers everything across your home
          </li>
          <li>
            Indulge in a First-Class lifestyle: more devices, premium speed,
            maximum capacity, and “Dedicated Concierge-Level” service
          </li>
          <li>
            Connect Everything & Everywhere with WiFi coverage that reaches
            across the house, garage, backyard, pool, and hot tub
          </li>
          <li>
            Expand the Gamer&rsquo;s mancave with Cityside Performance internet
            with the WiFi7 Router included
          </li>
          <li>
            Upgraded coverage across your home – indoor and outdoor mesh
            extenders included
          </li>
          <li>
            5 Gigs = 5,000 Mbps Upload and 5,000 Mbps Download
          </li>
        </ul>
      </PlanHero>

      <section className="plan-page__other-plans">
        <div className={`grid-12 plan-page__other-plans__container`}>
          <h2 className="headline__h1 color--marina-blue">
            Explore Other Packages
          </h2>

          <div className="plan-page__other-plans__container__plans-wrap">
            <PlanCard type="2 Gigs" gigInternetLinkText="Learn More">
              <h4 className="color--orange">
                The connection developed for remote workers and gamers who
                expect the best!
              </h4>

              <ul className="checkmark-list" data-mobile-text-size>
                <li>
                  Enjoy a seamless work-from-home connection and worry-free
                  video calls that will impress everyone!
                </li>
                <li>
                  Developed for Gaming, Entertaining, Security, and Smart Home
                  functionality, all running simultaneously
                </li>
                <li>
                  The Gamer&rsquo;s Secret Weapon – Ask us how to upgrade to the
                  newest WiFi7 Router and dominate the competition!
                </li>
                <li>
                  Prioritize your WiFi signal for important office devices
                  during work-from-home hours
                </li>
                <li>
                  Parents now have ExperienceIQ® to manage children&rsquo;s
                  online activities
                </li>
                <li>
                  Enhance your home&rsquo;s coverage – one mesh WiFi extender is
                  included to maximize your connection
                </li>
                <li>
                  2 Gigs = 2,000 Mbps Upload and 2,000 Mbps Download
                </li>
              </ul>
            </PlanCard>

            <PlanCard type="1 Gig" gigInternetLinkText="Learn More">
              <h4>
                The perfect plan for reliable connectivity at our lowest price!
              </h4>

              <ul className="checkmark-list" data-mobile-text-size>
                <li>
                  Finally, you can depend on an online connection built for your
                  needs and everyday internet use!
                </li>
                <li>
                  Control your internet experience across all household devices
                  with the MyCity WiFi app
                </li>
                <li>
                  Fantastic for streaming TV, social media, homework, and
                  optimizing your daily grind
                </li>
                <li>
                  Includes world-class cyber security ProtectIQ® to defend your
                  home network, devices, and data
                </li>
                <li>
                  1 Gig = 1,000 Mbps Upload and 1,000 Mbps Download
                </li>
              </ul>
            </PlanCard>
          </div>
        </div>
      </section>
    </>
  );
};
